module.exports = __webpack_public_path__ + "img/service-bak1.ddb3e491.png";